/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Step3description1Inputs */

const he_extension_step3description1 = /** @type {(inputs: Extension_Step3description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`המידע מ-PriceDrop יופיע אוטומטית בעמודי המוצרים`)
};

const en_extension_step3description1 = /** @type {(inputs: Extension_Step3description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PriceDrop data will appear automatically on product pages`)
};

/**
* | output |
* | --- |
* | "PriceDrop data will appear automatically on product pages" |
*
* @param {Extension_Step3description1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_step3description1 = /** @type {((inputs?: Extension_Step3description1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Step3description1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_step3description1(inputs)
	return en_extension_step3description1(inputs)
});
export { extension_step3description1 as "extension_step3Description" }